export default __webpack_public_path__ + "static/product-mel-manager-9540c6cb823c273eb81e743877059e43.svg";